import styled from "styled-components";

export const SocialHero = styled.ul`
    display: grid;
    grid-template-columns: max-content;
    row-gap: 1rem;

    a{
        color: var(--color-text);
        transition: .2s ease-in;

        &:hover{
            color: var(--color-black-hover);
        }
    }

    i{
        font-size: 1.25rem;
    }
`